import { render, staticRenderFns } from "./general-checkbox.vue?vue&type=template&id=632af8a0&scoped=true&"
import script from "./general-checkbox.vue?vue&type=script&lang=js&"
export * from "./general-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./general-checkbox.vue?vue&type=style&index=0&id=632af8a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632af8a0",
  null
  
)

export default component.exports